"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
var margins_1 = require("./margins");
exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  ", ";\n  ", ";\n  max-width: 1216px;\n"], ["\n  width: 100%;\n  ", ";\n  ", ";\n  max-width: 1216px;\n"])), margins_1.padding['24'].x, margins_1.margin['auto'].x);
exports.default = exports.Container;
var templateObject_1;
//# sourceMappingURL=container.js.map